module.exports = __webpack_public_path__ + "img/icon_employees_es.1f1f2528.png";